// extracted by mini-css-extract-plugin
export default {"loading":"CircleSpinner_loading__4v8K7"};